
import {
    Container,
    TextField,
    Typography,
    Accordion as MuiAccordion,
    AccordionSummary as MuiAccordionSummary,
    IconButton,
    Tab,
    Tabs,
    Card,
    CardContent,
    Divider,
    Grid,
    MenuItem,
    Box,
    Dialog,
    DialogTitle,
} from '@mui/material'
import { ExpandMore as ExpandMoreIcon, Delete as DeleteIcon, Close } from '@mui/icons-material'
import { FieldArray, Formik } from 'formik'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import * as Yup from 'yup'
import React from 'react'
import { ActionButton } from '../../../utils/ui_utils'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const Accordion = styled(MuiAccordion)({
    root: {
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',

        },
    },
    expanded: {},
})


const AccordionSummary = styled(MuiAccordionSummary)({
    root: {
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
});


function HeaderFooterDrawer({
    visible,
    title,
    okText,
    action = 'new',
    onClose,
    onSubmit,
    onAddButtonClick,
    onRemoveButtonClick,
    initialValues,
    outletData,
}) {

    if (initialValues == undefined) {
        initialValues = {
            outlet_id: '',
            Header: [
                {
                    text: '',
                    line_number: 1,
                    alignment: '',
                    width: false,
                    height: false,
                    font_size: '',
                    font: '',
                },
            ],
            Footer: [
                {
                    text: '',
                    line_number: 1,
                    alignment: '',
                    width: false,
                    height: false,
                    font_size: '',
                    font: '',
                },
            ],
        }
    }
    if (outletData == undefined)
        outletData = []
    let validationSchemaFormat;
    if (action == 'new') {
        validationSchemaFormat = Yup.object().shape({
            outlet_id: Yup.string().required('Required'),
            Header: Yup.array().of(
                Yup.object().shape({
                    text: Yup.string(),
                    line_number: Yup.number(),
                    alignment: Yup.string(),
                    font_size: Yup.number().required('Required').min(1, 'Minimum 1 required'),
                })
            ),
            Footer: Yup.array().of(
                Yup.object().shape({
                    text: Yup.string(),
                    line_number: Yup.number(),
                    alignment: Yup.string(),
                    font_size: Yup.number().required('Required').min(1, 'Minimum 1 required'),
                })
            ),
        })
    }
    else {
        validationSchemaFormat = Yup.object().shape({
            Header: Yup.array().of(
                Yup.object().shape({
                    text: Yup.string(),
                    line_number: Yup.number(),
                    alignment: Yup.string(),
                    font_size: Yup.number().required('Required').min(1, 'Minimum 1 required'),
                })
            ),
            Footer: Yup.array().of(
                Yup.object().shape({
                    text: Yup.string(),
                    line_number: Yup.number(),
                    alignment: Yup.string(),
                    font_size: Yup.number().required('Required').min(1, 'Minimum 1 required'),
                })
            ),
        })
    }
    const validationSchema = validationSchemaFormat

    const [value, setValue] = React.useState(0)
    const [expanded, setExpanded] = React.useState(false)

    const handleExpandChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }

    const handleTabChange = (event, newValue) => {
        setValue(newValue)
    }


    const handleSubmit = async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        onSubmit(values)
    }

    return (
        <>
            <Dialog
                maxWidth="sm"
                fullWidth
                anchor="right"
                backdrop="static"
                variant="temporary"
                open={visible}
            >

                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Divider />
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            setFieldValue,
                            status,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Card>
                                    <CardContent>
                                        <Grid container>
                                            <Grid item sm={12}>
                                                <Tabs value={value} onChange={handleTabChange}>
                                                    <Tab label="Header" {...a11yProps(0)} />

                                                    <Tab label="Footer" {...a11yProps(1)} />
                                                </Tabs>

                                                <FieldArray name="Header">
                                                    {({ insert, remove, push }) => (
                                                        <TabPanel value={value} index={0}>
                                                            {values.Header?.length > 0 &&
                                                                values.Header.map((header, i) => (
                                                                    <Accordion
                                                                        expanded={expanded === i}
                                                                        onChange={handleExpandChange(i)}
                                                                        key={i}
                                                                    >
                                                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                                            <Typography variant="body1" gutterBottom>
                                                                                {`Header ${i + 1}`}
                                                                            </Typography>
                                                                        </AccordionSummary>
                                                                        <Grid container spacing={6}>
                                                                            <Grid item md={2}>
                                                                                <TextField
                                                                                    size='small'
                                                                                    name={`Header.${i}.line_number`}
                                                                                    label="line number"
                                                                                    disabled
                                                                                    margin="dense"
                                                                                    value={values.Header[i].line_number}
                                                                                    error={Boolean(
                                                                                        touched.Header?.[i]?.line_number && errors.Header?.[i]?.line_number
                                                                                    )}
                                                                                    fullWidth
                                                                                    helperText={touched.Header?.[i]?.line_number && errors.Header?.[i]?.line_number}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={handleChange}
                                                                                    variant="outlined"
                                                                                    type="number"

                                                                                />
                                                                            </Grid>
                                                                            <Grid item md={10}>
                                                                                <TextField
                                                                                    size='small'
                                                                                    name={`Header.${i}.text`}
                                                                                    label="Text"
                                                                                    value={values.Header[i].text}
                                                                                    margin="dense"
                                                                                    error={Boolean(touched.Header?.[i]?.text && errors.Header?.[i]?.text)}
                                                                                    fullWidth
                                                                                    helperText={touched.Header?.[i]?.text && errors.Header?.[i]?.text}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={handleChange}
                                                                                    variant="outlined"

                                                                                />
                                                                            </Grid>

                                                                        </Grid>
                                                                        <Grid container spacing={6}>
                                                                            <Grid item md={4}>
                                                                                <TextField
                                                                                    size='small'
                                                                                    label="Alignment"
                                                                                    name={`Header.${i}.alignment`}
                                                                                    fullWidth
                                                                                    margin="dense"
                                                                                    value={values.Header[i].alignment}
                                                                                    variant="outlined"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    select
                                                                                >
                                                                                    <MenuItem value="left">Left</MenuItem>
                                                                                    <MenuItem value="center">Center</MenuItem>
                                                                                    <MenuItem value="right">Right</MenuItem>
                                                                                </TextField>
                                                                            </Grid>
                                                                            <Grid item md={4}>
                                                                                <TextField
                                                                                    size='small'
                                                                                    name={`Header.${i}.font_size`}
                                                                                    label="Font Size"
                                                                                    value={values.Header[i].font_size}
                                                                                    margin="dense"
                                                                                    error={Boolean(touched.Header?.[i]?.font_size && errors.Header?.[i]?.font_size)}
                                                                                    fullWidth
                                                                                    helperText={touched.Header?.[i]?.font_size && errors.Header?.[i]?.font_size}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={(event) => {
                                                                                        if (event.target.value < 0) {
                                                                                            setFieldValue(`Header.${i}.font_size`, 18)
                                                                                        }
                                                                                        else {
                                                                                            setFieldValue(`Header.${i}.font_size`, event.target.value)
                                                                                        }
                                                                                    }}
                                                                                    variant="outlined"
                                                                                />
                                                                            </Grid>
                                                                            <Grid item md={4}>
                                                                                <TextField
                                                                                    size='small'
                                                                                    name={`Header.${i}.font`}
                                                                                    label="Font"
                                                                                    margin="dense"
                                                                                    value={values.Header[i].font}
                                                                                    error={Boolean(touched.Header?.[i]?.font && errors.Header?.[i]?.font)}
                                                                                    fullWidth
                                                                                    helperText={touched.Header?.[i]?.font && errors.Header?.[i]?.font}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={handleChange}
                                                                                    variant="outlined"
                                                                                    select
                                                                                >
                                                                                    <MenuItem value="Times Roman">Times Roman</MenuItem>
                                                                                    <MenuItem value="Arial">Arial</MenuItem>
                                                                                    <MenuItem value="Helvatica">Helvatica</MenuItem>
                                                                                </TextField>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Accordion>
                                                                ))}
                                                        </TabPanel>
                                                    )}
                                                </FieldArray>

                                                <FieldArray name="Footer">
                                                    {({ insert, remove, push }) => (
                                                        <TabPanel value={value} index={1}>
                                                            {values.Footer?.length > 0 &&
                                                                values.Footer.map((footer, i) => (
                                                                    <Accordion
                                                                        expanded={expanded === i}
                                                                        onChange={handleExpandChange(i)}
                                                                        key={i}
                                                                    >
                                                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                                            <Typography variant="body1" gutterBottom>
                                                                                {`Footer ${i + 1}`}
                                                                            </Typography>

                                                                        </AccordionSummary>
                                                                        <Grid container spacing={6}>
                                                                            <Grid item md={2}>
                                                                                <TextField
                                                                                    size="small"
                                                                                    name={`Footer.${i}.line_number`}
                                                                                    label="line number"
                                                                                    margin="dense"
                                                                                    disabled
                                                                                    value={values.Footer[i].line_number}
                                                                                    error={Boolean(
                                                                                        touched.Footer?.[i]?.line_number && errors.Footer?.[i]?.line_number
                                                                                    )}
                                                                                    fullWidth
                                                                                    helperText={touched.Footer?.[i]?.line_number && errors.Footer?.[i]?.line_number}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={handleChange}
                                                                                    variant="outlined"
                                                                                    type="number"
                                                                                />
                                                                            </Grid>
                                                                            <Grid item md={10}>
                                                                                <TextField
                                                                                    size="small"
                                                                                    name={`Footer.${i}.text`}
                                                                                    label="Text"
                                                                                    value={values.Footer[i].text}
                                                                                    margin="dense"
                                                                                    error={Boolean(touched.Footer?.[i]?.text && errors.Footer?.[i]?.text)}
                                                                                    fullWidth
                                                                                    helperText={touched.Footer?.[i]?.text && errors.Footer?.[i]?.text}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={handleChange}
                                                                                    variant="outlined"
                                                                                />
                                                                            </Grid>

                                                                        </Grid>
                                                                        <Grid container spacing={6}>
                                                                            <Grid item md={4}>
                                                                                <TextField
                                                                                    size="small"
                                                                                    label="Alignment"
                                                                                    name={`Footer.${i}.alignment`}
                                                                                    fullWidth
                                                                                    margin="dense"
                                                                                    value={values.Footer[i].alignment}
                                                                                    variant="outlined"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    select
                                                                                >
                                                                                    <MenuItem value="left">Left</MenuItem>
                                                                                    <MenuItem value="center">Center</MenuItem>
                                                                                    <MenuItem value="right">Right</MenuItem>
                                                                                </TextField>
                                                                            </Grid>
                                                                            <Grid item md={4}>
                                                                                <TextField
                                                                                    size="small"
                                                                                    name={`Footer.${i}.font_size`}
                                                                                    label="Font Size"
                                                                                    value={values.Footer[i].font_size}
                                                                                    margin="dense"
                                                                                    error={Boolean(touched.Footer?.[i]?.font_size && errors.Footer?.[i]?.font_size)}
                                                                                    fullWidth
                                                                                    helperText={touched.Footer?.[i]?.font_size && errors.Footer?.[i]?.font_size}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={(event) => {
                                                                                        if (event.target.value < 0) {
                                                                                            setFieldValue(`Footer.${i}.font_size`, 18)
                                                                                        }
                                                                                        else {
                                                                                            setFieldValue(`Footer.${i}.font_size`, event.target.value)
                                                                                        }
                                                                                    }}
                                                                                    variant="outlined"

                                                                                />
                                                                            </Grid>
                                                                            <Grid item md={4}>
                                                                                <TextField
                                                                                    size="small"
                                                                                    name={`Footer.${i}.font`}
                                                                                    label="Font"
                                                                                    margin="dense"
                                                                                    value={values.Footer[i].font}
                                                                                    error={Boolean(touched.Footer?.[i]?.font && errors.Footer?.[i]?.font)}
                                                                                    fullWidth
                                                                                    helperText={touched.Footer?.[i]?.font && errors.Footer?.[i]?.font}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={handleChange}
                                                                                    variant="outlined"
                                                                                    select
                                                                                >
                                                                                    <MenuItem value="Times Roman">Times Roman</MenuItem>
                                                                                    <MenuItem value="Arial">Arial</MenuItem>
                                                                                    <MenuItem value="Helvatica">Helvatica</MenuItem>

                                                                                </TextField>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Accordion>
                                                                ))}
                                                        </TabPanel>
                                                    )}
                                                </FieldArray>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item  >
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                            {okText}
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>

                </Container>
            </Dialog>
        </>
    )

}

export default HeaderFooterDrawer